import React__default from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/TextArea.scss';

var _excluded = ["id", "className", "labelClassName", "name", "label", "errors", "value"];
var TextAreaErrors = function TextAreaErrors(_ref) {
  var errors = _ref.errors,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.errors, className)
  }, errors.map(function (x) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: x,
      className: styles.error
    }, x);
  }));
};
var TextArea = function TextArea(_ref2) {
  var _cn;
  var _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? null : _ref2$id,
    className = _ref2.className,
    labelClassName = _ref2.labelClassName,
    name = _ref2.name,
    label = _ref2.label,
    errors = _ref2.errors,
    value = _ref2.value,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, (_cn = {}, _cn[styles.error] = errors && errors.length > 0, _cn))
  }, label && /*#__PURE__*/React__default.createElement("label", {
    id: id,
    className: cn(styles.label, labelClassName)
  }, label), /*#__PURE__*/React__default.createElement("textarea", _extends({}, props, {
    value: value,
    id: id,
    className: cn(styles.input, className),
    name: name,
    rows: "4"
  })), errors && errors.length > 0 && /*#__PURE__*/React__default.createElement(TextAreaErrors, {
    errors: errors
  }));
};

export { TextArea, TextAreaErrors };
//# sourceMappingURL=index.js.map
